import { useCallback, useEffect, useState } from 'react';

/**
 * Shared state manager for Lab 2 pages that provides
 * consistent filter handling and tab expansion tracking.
 */
const useLab2PageState = ({ defaultFilter = null, defaultExpanded = true } = {}) => {
    const [currentFilter, setCurrentFilter] = useState(defaultFilter);
    const [isTabExpanded, setIsTabExpanded] = useState(defaultExpanded);

    useEffect(() => {
        setIsTabExpanded(defaultExpanded);
    }, [defaultExpanded]);

    const handleFilterChange = useCallback((tabIndex, value) => {
        if (value === undefined || value === null) {
            setCurrentFilter(null);
            return;
        }

        setCurrentFilter({ tabIndex, value });
    }, []);

    const handleTabExpandedChange = useCallback((expanded) => {
        setIsTabExpanded(expanded);
    }, []);

    return {
        currentFilter,
        isTabExpanded,
        handleFilterChange,
        handleTabExpandedChange,
        setCurrentFilter,
        setIsTabExpanded,
    };
};

export default useLab2PageState;
